import React from "react";

import Applet from "../../Applet";
import ProjectPlanTable from "../../../../components/ProjectPlan/ProjectPlanTable";

class ProjectPlanTableApplet extends Applet {

    render() {
        return <ProjectPlanTable applet={this}
                                 pageSize={this.props.PageSize ? this.props.PageSize : this.state.PageSize}
                                 placement={this.state.Placement}
                                 columns={this.state.Columns}
                                 title="Project Plans"
                                 enterpriseComponent={this.getEnterpriseComponent()}
                                 sort={this.state.Sort}
                                 menu={this.state.Menu}
                                 rowHeight={this.state.RowHeight}
                                 simpleSearch={this.state.SimpleSearch}
                               // enableSort={true}
                               // enableSearch={true}

        />;
    }

    state = {
        Name: "ProjectPlanTableApplet",
        Menu: {
            options: [
                {
                    privileges: [
                        "Add Plan"
                    ],
                    displayValue: "New Project Plan",
                    value: "New Project Plan",
                },
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 60,
        PageSize: {
            "default": 20,
            "xs": 3,
            "sm": 3,
            "md": 10,
            "lg": 20,
            "lx": 20,
        },
        Placement: {
            "xl": [
                {
                    id: "RecordPointer",
                },
                {
                    id: "ProjectPlanID",
                },
                {
                    id: "Name",
                },
                {
                    id: "Status",
                },
                {
                    id: "CreatedByUserName",
                },
                {
                    id: "CreatedDatetime",
                },
                {
                    id: "CompletedOnDatetime",
                }
            ]
        },
        Columns: [
            {
                id: "RecordPointer",
                width: 25,
                cellRenderer: "Row Selection Indicator Cell",
                header: null,
                headerRenderer: "",
                headerTitle: "",
            },
            {
                id: "ProjectPlanID",
                width: 130,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Project Plan ID",
            },
            {
                id: "Name",
                width: 600,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Name",
            },
            {
                id: "Status",
                width: 150,
                cellRenderer: "Status Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Status",
            },
            {
                id: "CreatedByUserName",
                width: 180,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Created By",
            },
            {
                id: "CreatedDatetime",
                width: 180,
                cellRenderer: "Local Date Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Created On",
            },
            {
                id: "CompletedOnDatetime",
                width: 180,
                cellRenderer: "Local Date Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Completed On",
            }
        ],
        Sort: [
            {
                "Identifier": "Project Plan ID",
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "ProjectPlanID",
                    "DisplayName": "Project Plan ID",
                }],
            },
            {
                "Identifier": "Name/Status",
                "Visible": true,
                "Default": false,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "Name",
                    "DisplayName": "Name",
                },
                {
                    "Direction": "ASC",
                    "SortAttribute": "Status",
                    "DisplayName": "Status",
                }
                ]
            }
        ],
        SimpleSearch: {
            Actions: {
                Query: {
                    Groups: [
                        {
                            "identifier": "group1",
                            "type": "standard",
                            "selector": null,
                            "characteristics": [],
                            "membership": [
                                {
                                    id: "ProjectPlanID",
                                },
                                {
                                    id: "Name",
                                },
                                {
                                    id: "Status",
                                },
                                {
                                    id: "CreatedByUSID",
                                },
                                {
                                    id: "CreatedDatetime",
                                },
                                {
                                    id: "CompletedOnDatetime",
                                },
                            ]
                        }
                    ]
                }
            },
            Controls: {
                "ProjectPlanID": {
                    id: "ProjectPlanID",
                    enterpriseComponentAttribute: "ProjectPlanID",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [
                        {
                            validator: "No Special Characters",
                            value: null,
                            errorText: "Field must not have special characters.",
                        },
                        {
                            validator: "No Leading Spaces",
                            value: null,
                            errorText: "Field must not have leading spaces.",
                        },
                        {
                            validator: "Not All Spaces",
                            value: null,
                            errorText: "Field must not have all spaces.",
                        },

                    ],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Project Plan ID",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "TextField",
                    requiresConfirmation: false,
                },
                "Name": {
                    id: "Name",
                    enterpriseComponentAttribute: "Name",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [
                        {
                            validator: "No Special Characters",
                            value: null,
                            errorText: "Field must not have special characters.",
                        },
                        {
                            validator: "No Leading Spaces",
                            value: null,
                            errorText: "Field must not have leading spaces.",
                        },
                        {
                            validator: "Not All Spaces",
                            value: null,
                            errorText: "Field must not have all spaces.",
                        },

                    ],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Name",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "TextField",
                    requiresConfirmation: false,
                },
                "Status": {
                    id: "Status",
                    enterpriseComponentAttribute: "Status",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Status",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "Select",
                    requiresConfirmation: false,
                },
                "CreatedByUSID": {
                    id: "CreatedByUSID",
                    enterpriseComponentAttribute: "CreatedByUSID",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [
                        {
                            validator: "No Special Characters",
                            value: null,
                            errorText: "Field must not have special characters.",
                        },
                        {
                            validator: "No Leading Spaces",
                            value: null,
                            errorText: "Field must not have leading spaces.",
                        },
                        {
                            validator: "Not All Spaces",
                            value: null,
                            errorText: "Field must not have all spaces.",
                        },

                    ],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Created By",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "Select",
                    requiresConfirmation: false,
                },
                "CreatedDatetime": {
                    id: "CreatedDatetime",
                    enterpriseComponentAttribute: "CreatedDatetime",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 3,
                            md: 3,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Created On",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "DateTime",
                    requiresConfirmation: false,
                },
                "CompletedOnDatetime": {
                    id: "CompletedOnDatetime",
                    enterpriseComponentAttribute: "CompletedOnDatetime",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 3,
                            md: 3,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Completed On",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "DateTime",
                    requiresConfirmation: false,
                },
            }
        }
    }
}

export default ProjectPlanTableApplet;
